import React from "react";
import "./Aml.css";

const AMLPolicy = () => {
  return (
    <div className="aml-container">
      <h1>Политика противодействия отмыванию денег (AML)</h1>
      <p>
        Favorite Crypto Exchange придерживается строгих стандартов по противодействию
        отмыванию денег (AML) и финансированию терроризма (CFT). Мы внедряем
        надежные механизмы идентификации клиентов (KYC) и мониторинга
        транзакций для обеспечения безопасности и прозрачности платформы.
      </p>
      
      <h2>Процедуры KYC</h2>
      <p>
        Для предотвращения незаконных операций мы требуем от пользователей
        предоставления документов, удостоверяющих личность, подтверждения адреса
        проживания, а также иной информации, необходимой для идентификации.
      </p>
      
      <h2>Мониторинг транзакций</h2>
      <p>
        Мы используем автоматизированные системы анализа транзакций, которые
        позволяют выявлять подозрительную активность, связанную с отмыванием
        денег или финансированием терроризма.
      </p>
      
      <h2>Обязанности клиентов</h2>
      <p>
        Клиенты обязаны предоставлять точные и актуальные данные, а также
        соблюдать политику AML, установленную Favorite Crypto Exchange. В случае
        выявления подозрительной активности, администрация оставляет за собой
        право приостановить операции и запросить дополнительные документы.
      </p>
      
      <h2>Сотрудничество с регулирующими органами</h2>
      <p>
        Мы сотрудничаем с правоохранительными и финансовыми регулирующими
        органами, предоставляя им необходимую информацию в рамках действующего
        законодательства.
      </p>
      
      <h2>Изменения в политике AML</h2>
      <p>
        Мы оставляем за собой право вносить изменения в политику AML в
        соответствии с законодательством и внутренними регламентами.
      </p>
    </div>
  );
};

export default AMLPolicy;